import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { playSound } from '../App/actions';
import { HOVER_BUTTON_SOUND, CLICK_BUTTON_SOUND } from '../../sounds';

function createPlaySoundFactory(triggerSound) {
  return sound => () => {
    if (sound) {
      triggerSound(sound);
    }
  };
}

function withSounds({
  mouseEnterSound,
  mouseLeaveSound,
  mouseUpSound,
  mouseDownSound
}) {
  if (true === mouseEnterSound) {
    // Use default hover sound when true.
    mouseEnterSound = HOVER_BUTTON_SOUND;
  }

  if (true === mouseUpSound) {
    // Use default click sound when true.
    mouseUpSound = CLICK_BUTTON_SOUND;
  }

  return function wrapWithSounds(WrappedComponent) {
    class Sounds extends Component {
      render() {
        const { triggerSound, ...otherProps } = this.props;
        const playSound = createPlaySoundFactory(triggerSound);

        return (
          <WrappedComponent
            onMouseEnter={playSound(mouseEnterSound)}
            onMouseLeave={playSound(mouseLeaveSound)}
            onMouseDown={playSound(mouseDownSound)}
            onMouseUp={playSound(mouseUpSound)}
            {...otherProps}
          />
        );
      }
    }

    Sounds.propTypes = {
      triggerSound: PropTypes.func
    };

    function mapDispatchToProps(dispatch) {
      return {
        triggerSound: sound => dispatch(playSound(sound))
      };
    }

    return connect(null, mapDispatchToProps)(Sounds);
  };
}

export default withSounds;



// WEBPACK FOOTER //
// ./src/containers/withSounds/index.js